import React from 'react';
import './Logo.css';
import logoImage from '../logo/Logo.svg';

const Logo = () => {
  return (
    <div className="logo">
      <img src={logoImage} alt="Skyline Steel Design" className="logo-image" />
    </div>
  );
};

export default Logo;

